/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactCopyrightWithRelations } from '../../models/contact-copyright-with-relations';

export interface GetCopyrightsByContact$Params {
  contactId: string;
}

export function getCopyrightsByContact(http: HttpClient, rootUrl: string, params: GetCopyrightsByContact$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactCopyrightWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, getCopyrightsByContact.PATH, 'get');
  if (params) {
    rb.query('contactId', params.contactId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactCopyrightWithRelations>>;
    })
  );
}

getCopyrightsByContact.PATH = '/editor/contact-copyrights';
